import React, { useEffect, useState } from 'react';
import { fetchPublicAnnouncements } from '../../services/site';

const colorMap = {
  primary: 'bg-primary text-primary-foreground',
  secondary: 'bg-secondary text-secondary-foreground',
  warning: 'bg-yellow-500 text-black',
  success: 'bg-green-600 text-white',
};

const AnnouncementBanner = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [hiddenIds, setHiddenIds] = useState([]);

  useEffect(() => {
    try {
      const ls = JSON.parse(localStorage.getItem('padaid_hidden_announcements') || '[]');
      setHiddenIds(ls);
    } catch (e) {}
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetchPublicAnnouncements();
        setAnnouncements(res.announcements || []);
      } catch (e) { /* ignore */ }
    };
    load();
  }, []);

  const hide = (id) => {
    const next = [...hiddenIds, id];
    setHiddenIds(next);
    localStorage.setItem('padaid_hidden_announcements', JSON.stringify(next));
  };

  const visible = (announcements || []).filter(a => !hiddenIds.includes(a.id));
  if (!visible.length) return null;

  return (
    <div className="w-full">
      {visible.map(a => (
        <div key={a.id} className={`w-full ${colorMap[a.color || 'primary']} text-sm py-2 px-3 text-center relative`}>
          <div className="max-w-6xl mx-auto">
            <span className="font-medium">{a.title}:</span> {a.message}
            {a.link_url && (
              <a href={a.link_url} className="underline ml-2" target="_blank" rel="noreferrer">En savoir plus</a>
            )}
          </div>
          <button onClick={() => hide(a.id)} className="absolute right-2 top-1/2 -translate-y-1/2 text-xs opacity-80 hover:opacity-100">Fermer</button>
        </div>
      ))}
    </div>
  );
};

export default AnnouncementBanner;